import { Children, type ReactNode, isValidElement } from 'react'

import {
  GridLayoutItem,
  GridLayoutView,
  type GridLayoutViewComponentProps,
} from '../../components/GridLayout'
import { createWidget } from '../widget-utils'

export type GridLayoutViewWidgetProps = GridLayoutViewComponentProps & {
  isLoading?: boolean
  children?: ReactNode
}

/**
 * CMS entry for {@link GridLayoutView}.
 * GL-R-12: wraps each child in {@link GridLayoutItem} so content widgets can
 * sit directly under the layout without a separate item widget type.
 */
export const GridLayoutViewWidget = ({
  isLoading: _isLoading,
  children,
  ...props
}: GridLayoutViewWidgetProps) => (
  <GridLayoutView {...props}>
    {Children.map(children, child => {
      if (!isValidElement(child)) return child
      return <GridLayoutItem>{child}</GridLayoutItem>
    })}
  </GridLayoutView>
)

export const GridLayoutViewWidgetDefinition = createWidget(
  GridLayoutViewWidget,
  {
    type: 'GridLayoutView',
  },
)
